// The confirm dialog the References and Rules managers open before making a
// row Inactive or Active — one copy for both screens (code review G-10).
// One sentence, then the buttons 24px below it (`dialogForm.ts`, D-349).
import {
  Body1,
  Button,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from '@fluentui/react-components'
import { AppDialog } from './AppDialog'
import { FrozenWhileClosed } from './FrozenWhileClosed'
import { useDialogFormStyles } from './dialogForm'

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  busy,
  onConfirm,
  onCancel,
}: {
  open: boolean
  title: string
  body: string
  confirmLabel: string
  busy: boolean
  onConfirm: () => void
  onCancel: () => void
}) {
  const f = useDialogFormStyles()
  return (
    <AppDialog open={open} onOpenChange={(_, d) => !d.open && onCancel()}>
      <DialogSurface>
        <FrozenWhileClosed open={open}><DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent className={f.beforeActions}>
            <Body1>{body}</Body1>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onCancel} disabled={busy}>
              Cancel
            </Button>
            <Button appearance="primary" onClick={onConfirm} disabled={busy}>
              {confirmLabel}
            </Button>
          </DialogActions>
        </DialogBody></FrozenWhileClosed>
      </DialogSurface>
    </AppDialog>
  )
}
